import styled from 'styled-components';

const Form = styled.form`
  padding-top: 3rem;

  input,
  select,
  textarea {
    border-radius: .25rem;
    background-color: ${({ theme }) => theme.backgroundColor};
    border: 1px solid ${({ theme }) => theme.grayLightColor};
    min-height: 2.429rem;
    padding: 0 .5rem;
    width: 100%;
    box-sizing: border-box;
  }
  textarea {
    padding: .5rem;
    min-height: 12rem;
  }
`;

export default Form;
